import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What ages can participate in family class?',
  answer: 'Family class is generally for parents and children ages 6 and up. Storm also has Mini Troopers (ages 3-5) and Kids Taekwondo (ages 6+) if a family member is a little younger or wants a kids-only class.'
}, {
  question: 'Do we need to be at the same skill level?',
  answer: 'No. Families often start together, but even if one person progresses faster or joins later, our coaches tailor drills so everyone is appropriately challenged. Family classes are intentionally designed for mixed ages and skill levels.'
}, {
  question: 'Is it actually a real workout for the parents?',
  answer: 'Yes. The environment is positive and family-friendly, but the drills and conditioning give adults a full-body workout — cardio, strength, flexibility, and core stability all rolled into one class.'
}, {
  question: 'What if one parent wants to train but the other prefers to watch?',
  answer: "That works perfectly fine. Many families have one parent on the mat and the other cheering. Some families rotate. There's no right way — only what works for your family."
}, {
  question: 'Do you offer a trial class for the whole family?',
  answer: 'Yes. Fill out the form on this page or call 517-220-0621 and we will schedule a family trial class so everyone can experience Storm before committing.'
}, {
  question: 'Where is Storm located and which areas do you serve?',
  answer: 'Storm Taekwondo is at 24786 Crestview, Farmington Hills, MI 48335. We serve families from Farmington Hills, Farmington, Commerce, Walled Lake, Wixom, Novi, Northville, Livonia, White Lake, Waterford, Milford, West Bloomfield, and other Southeast Michigan communities.'
}];
export function FamilyFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-1078" />;
}